<template>
  <Container
    class="container--tablet"
  >
    <template #component>
      <v-col class="container__col">
        <Account />
      </v-col>
    </template>
  </Container>
</template>

<script>
import { breakpoints } from '@/mixins'
import Container from '@/views/Layout/Container.vue'
import Account from '@/components/Edit-Account/Account.vue'

export default {
  name: 'EditUser',
  components: {
    Container,
    Account,
  },
  mixins: [breakpoints],
  data() {
    return {
      tabs: [`${this.$t('menu.account')}`, `${this.$t('menu.info')}`],
    }
  },
}
</script>
